import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, FreeMode, Mousewheel, Navigation, Pagination, Thumbs } from 'swiper/modules';

import { $Elements, Durations, Events } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Dates ----------

	$('.dates-section').each(function() {

		const slider = this.querySelector('.date-slider');
		const navigation = this.querySelector('.date-navigation-slider');

		if(navigation && !navigation.swiper) {

			const navigationSwiper = new Swiper(navigation, {
				modules: [FreeMode, Mousewheel],
				speed: Durations.default.ms,
				slideToClickedSlide: true,
				slidesPerView: 'auto',
				centerInsufficientSlides: true,
				observer: true,
				freeMode: {
					enabled: true,
					sticky: true,
				},
				watchSlidesProgress: true,
				mousewheel: {
					sensitivity: 2
				},
			});

			if(slider && !slider.swiper) {

				const mainSwiper = new Swiper(slider, {
					modules: [Thumbs, EffectFade],
					speed: Durations.default.ms,
					slidesPerView: 1,
					observer: true,
					loop: false,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
					thumbs: {
						swiper: navigationSwiper,
					}
				});
			}
		}
	});

	// ---------- Carousel ----------

	$('.content-section').each(function() {

		const section = this;

		$(section).find('.section-carousel, .column-carousel').each(function() {

			const carousel = this;

			if(!carousel.swiper) {

				const swiper = new Swiper(carousel, {
					speed: Durations.animations.ms,
					loop: false,
					observer: true,
					slidesPerView: 'auto',
					modules: [Navigation, Pagination],
					pagination: {
						el: section.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: section.querySelector('.swiper-button-next'),
						prevEl: section.querySelector('.swiper-button-prev'),
					},
				});
			}
		});
	});

	// ---------- Slideshow ----------

	$('.content-section').each(function() {

		const section = this;

		$(section).find('.section-slideshow, .column-slideshow').each(function() {

			const slideshow = this;

			if(!slideshow.swiper) {

				const swiper = new Swiper(slideshow, {
					speed: Durations.animations.ms,
					loop: true,
					observer: true,
					autoplay: true,
					effect: 'fade',
					modules: [Autoplay, EffectFade, Navigation, Pagination],
					fadeEffect: {
						crossFade: true,
					},
					pagination: {
						el: section.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: section.querySelector('.swiper-button-next'),
						prevEl: section.querySelector('.swiper-button-prev'),
					},
				});
			}
		});
	});
});
